<template>
    <div>
        <v-form
            v-model="isValid"
            @submit.prevent="noOperation"
            class="mt-2"
        >
            <v-text-field
                v-model="kelonUrl"
                autofocus
                ref="input"
                label="URL"
                :hint="`Contoh: ${kelonClassUrlExample}`"
                :rules="kelonUrlRule"
                prepend-icon="mdi-link-variant"
                :loading="isTextInputLoading"
            ></v-text-field>
        </v-form>

        <div v-if="group">
            <b>Kelas:</b>
            {{ group.title }}
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        kelonUrl: null,
        isValid: null,
        isTextInputLoading: false,
        group: null,
    }),

    watch: {
        kelonUrl() {
            this.group = null
        },

        async isValid() {
            if (this.isValid && this.kelonUrl) {
                const matches = this.kelonUrl.match(/\d+$/)
                this.isTextInputLoading = true

                this.group = await this.getGroupById(matches[0])

                this.isTextInputLoading = false
            }
        },

        group() {
            this.$emit('input', this.group.id)
        },
    },

    computed: {
        kelonClassUrlExample() {
            return `${process.env.VUE_APP_KELON_URL}video/manager/1`
        },

        kelonUrlRule() {
            return [
                (value) => {
                    const kelonUrl = process.env.VUE_APP_KELON_URL
                    const re = new RegExp(`^${kelonUrl}video/manager/\\d+$`)

                    return re.test(value)
                        ? true
                        : `Contoh: ${this.kelonClassUrlExample}`
                },
            ]
        },
    },

    methods: {
        noOperation() {},

        async getGroupById(id, option) {
            const response = await this.$apiv2.get(
                `kelon-access/group/${id}`,
                option
            )

            return response.data
        },
    },
}
</script>
